import { createSlice } from '@reduxjs/toolkit';
import { SCENARIOS, SOURCE_OPTIONS, USER_DEFINED_SCENARIO } from '../../constants';
import { Utils } from '../../utils';
import _ from 'lodash';

/* ----------------------------------------------------------------
      SLICE (ACTIONS/REDUCERS)
---------------------------------------------------------------- */

const initialState = {
  default: {
    region: '',
    source: SOURCE_OPTIONS[0].value,
    pathway: '',
    scenario: SCENARIOS[0].value,
    visualisation: '',
    levers: [],
    url: '',
  },
  global: {
    visualisation: '',
  },
  current: {
    region: '',
    source: '',
    pathway: '',
    scenario: SCENARIOS[0].value,
    levers: [],
    url: '',
  },
  locked: {},
  concat: {
    region: [],
    pathway: [],
    levers: [],
    regionPathway: [],
  },
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    updateFilter(state, action) {
      state.current = {
        ...state.current,
        [action.payload.name]: action.payload.value,
      };
    },
    updateLockedFilter(state, action) {
      state.locked = {
        ...state.locked,
        [action.payload.name]: action.payload.value,
      };
    },
    updateGlobalFilter(state, action) {
      state.global = {
        ...state.global,
        [action.payload.name]: action.payload.value,
      };
    },
    swapCurrentLockedFilters(state) {
      const current = state.current;
      const locked = state.locked;
      state.current = { ..._.cloneDeep(locked) };
      state.locked = { ..._.cloneDeep(current) };
    },
    lockCurrentFilters(state) {
      state.locked = { ..._.cloneDeep(state.current) };
    },
    resetLockedFilters(state) {
      state.locked = { ...initialState.locked };
      state.concat = { ...initialState.concat };
    },
    updateConcatFilters(state, action) {
      state.concat = {
        region: [...state.concat.region, _.cloneDeep(state.current.region)],
        pathway: [...state.concat.pathway, action.payload.additionalPathway],
        levers: [...state.concat.levers, _.cloneDeep(state.current.levers)],
        regionPathway: [...state.concat.regionPathway, action.payload.additionalRegionPathway],
        source: state.current.source,
        visualisation: state.global.visualisation,
      };
    },
    removeConcatFiltersByIndex(state, action) {
      state.concat = { ...action.payload };
    },
  },
});

export const {
  updateFilter,
  updateLockedFilter,
  updateGlobalFilter,
  swapCurrentLockedFilters,
  lockCurrentFilters,
  resetLockedFilters,
  concatFilters,
  removeConcatFiltersByIndex,
  updateConcatFilters,
} = filterSlice.actions;
export default filterSlice.reducer;

/* ----------------------------------------------------------------
      MIDDLEWARE - API CALLS
---------------------------------------------------------------- */
export const concatLockedFilters = () => {
  return async (dispatch, getState) => {
    const { globalDomain } = getState();
    const { pathway, region } = globalDomain.filters.current;
    const { regionPathway } = globalDomain.filters.concat;

    let additionalPathway;
    if (pathway === USER_DEFINED_SCENARIO) {
      const elementToSearch = `${region} - User`;
      const numberUserDefinedScenario = Utils.countStringInArray(regionPathway, elementToSearch);
      additionalPathway = pathway + ' ' + numberUserDefinedScenario;
    } else {
      additionalPathway = pathway;
    }

    const additionalRegionPathway = `${region} - ${pathway}`;

    dispatch(updateConcatFilters({ additionalPathway, additionalRegionPathway }));
  };
};
